import Pagination, { PaginationProps } from "../../Pagination"
import { useTableContext } from "./TableContext";
import Select from '@able/react/dist/Select';

export const TablePaginationInfo = () => {

    const { paginationRowInfoStart, paginationRowInfoEnd, totalRecords, paginationShouldActive } = useTableContext();

    if (!paginationShouldActive) return null;

    return (<div className='ted-ui-TablePageInfo' data-testid="pagesizeChanger">
        <span>
            Showing <b>{paginationRowInfoStart}</b>-<b>{paginationRowInfoEnd}</b> of <b>{totalRecords}</b> items.
        </span>
        <TablePageSizeSelector id={'page-size-selector-top-control'} />
    </div>)
}

export const TablePageSizeSelector = ({ id }: { id?: string }) => {
    const { pageSizeOptions = [], pageSize, onPageSizeChange, paginationShouldActive } = useTableContext();

    if (!paginationShouldActive) return null;

    return <div className='ted-ui-TablePageSizeSelector'>
        <Select
            label={'Items per page'}
            options={(pageSizeOptions?.map(it => ({
                label: it.toString(),
                value: it.toString()
            })) as any)}
            allowEmpty={false}
            id={id ?? 'ted-ui-table-pageSize-selector'}
            value={pageSize?.toString()}
            events={{
                onChange: (event: any) => {
                    onPageSizeChange && onPageSizeChange(Number(event.target.value))
                }
            }}
        />
    </div>
}

const TablePagination = () => {
    const { developmentUrl, data, totalRecords, page = 1, pageSize = 10, onPageChange, paginationClassName, paginationShouldActive } = useTableContext();

    if (!paginationShouldActive) return null;
    /**
      * Setting the pagination prop
      */
    const paginationProps: PaginationProps = {
        totalRecords: totalRecords ?? data.length,
        page: page,
        pageSize: pageSize,
        onPageChange: onPageChange as any,
        paginationClassName
    }

    return (
        <Pagination {...paginationProps} developmentUrl={developmentUrl} />
    )
}

export default TablePagination